import React, { useState, useEffect, useReducer } from "react";
import moment from "moment";
import {
  Grid,
  Button,
  List,
  Box,
  TextField,
  Avatar,
  Divider,
  Radio,
  RadioGroup,
  FormControl,
  InputLabel,
  Typography,
  TablePagination,
  Switch,
  Backdrop,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  CardContent,
  Card,
  CardActions,
  Tooltip,
  Link,
  Chip,
  FormControlLabel,
  withStyles,
} from "@material-ui/core";
import { MdOutlineSick, MdOutlineTagFaces } from "react-icons/md";
import PageTitle from "../../../../components/PageTitle";
import { toast } from "react-toastify";
import { FaDotCircle } from "react-icons/fa";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Controller, useForm } from "react-hook-form";
import EditIcon from "@material-ui/icons/Edit";
import useStyles from "../../../../themes/style.js";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { addMonths } from "date-fns/addMonths";
import "../../../../css/employee-page.css";
import { useNotification } from "../../../../hooks/useNotification.js";
import { IoCheckmark, IoCloseOutline } from "react-icons/io5";
import { LuClock } from "react-icons/lu";
import { capitalizeFirstLetter } from "../../../../utils/constant.js";
import { HiQuestionMarkCircle } from "react-icons/hi2";
import NoDataFound from "../../../../components/NoDataFound/index.js";

const InformationTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: "#c8d8f8",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 250,
    fontFamily: "'Inter', sansSerif",
    fontSize: theme.typography.pxToRem(12),
    border: "1px solid #7da5f6",
  },
  arrow: {
    color: "#7da5f6",
  },
}))(Tooltip);

const StatusChip = ({ status }) => {
  const getChipProperties = (status) => {
    switch (status) {
      case "APPROVED":
        return {
          label: "Approved",
          color: "#D4EDDA", // Light green background
          textColor: "#155724", // Dark green text
          Icon: IoCheckmark, // Dark green text
        };
      case "REJECTED":
        return {
          label: "Rejected",
          color: "#F8D7DA", // Light red background
          textColor: "#721C24", // Dark red text
          Icon: IoCloseOutline, // Dark red text
        };
      case "PENDING":
        return {
          label: "Pending",
          color: "#FFF3CD", // Light yellow background
          textColor: "#856404", // Dark yellow text
          Icon: LuClock, // Dark yellow text
        };
      default:
        return {
          label: "Unknown",
          color: "#E0E0E0", // Gray background
          textColor: "#6C757D", // Gray text
          Icon: FaDotCircle, // Gray text
        };
    }
  };

  const { label, color, textColor, Icon } = getChipProperties(status);

  return (
    <Chip
      style={{
        backgroundColor: color,
        color: textColor,
        fontWeight: "bold",
      }}
      size="small"
      label={label}
      icon={<Icon style={{ color: textColor }} />}
    />
  );
};

export default function YetToActionPermissionList() {
  const classes = useStyles();
  const handleNotificationCall = useNotification();
  const token = localStorage.getItem("token");
  const [loader, setLoader] = useState(false);

  const mobileQuery = useMediaQuery("(max-width:600px)");

  const [page, setPage] = useState(0);
  const [currerntPage, setCurrerntPage] = useState(1);
  const [count, setCount] = useState(0);

  const [pendingPermissionData, setPendingLeaveData] = useState([]);
  const [feedbackModalOpen, setFeedbackModalOpen] = useState(false);

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [leaveDetails, setLeaveDetails] = useState([]); // Key-value pairs for leave days

  useEffect(() => {
    fetchPendingLeaves();
  }, []);

  const fetchPendingLeaves = async () => {
    try {
      setLoader(true);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_SERVER}permission/viewStatusWisePermissions`,
        data: { page:  currerntPage    
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
       
      }).then(function (response) {
        if (response.data.status === true) {
          setLoader(false);
          const responseData = response.data.data;
          setPendingLeaveData(responseData);
          setCount(response.data.count);
        }
      });
    } catch (error) {
      console.log(error);
      setLoader(false);
    }
  };

  

  
  // const handleChangePage = async (event, newPage) => {
  //   setPage(newPage);
  //   setLoader(true);
  //   setCurrerntPage(newPage + 1);

  //   const thisPage = newPage + 1;

  //   axios({
  //     method: "get",
  //     url: `${process.env.REACT_APP_SERVER}leave/viewAllPendingLeave?page=${thisPage}`,
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: token,
  //     },
  //   }).then(function (response) {
  //     if (response.data.status === true) {
  //       setPendingLeaveData(response.data.data);
  //       setCount(response.data.count);
  //     }
  //     setLoader(false);
  //   });
  // };

  const getDatesInRange = (startDate, endDate) => {
    const date = new Date(startDate);
    const dates = [];
    while (date <= endDate) {
      dates.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return dates;
  };

  const isSameDay = (date1, date2) =>
    date1.toDateString() === date2.toDateString();

  const excludedDates = [
    new Date(2024, 11, 14), // 14 Dec
    new Date(2024, 11, 15), // 15 Dec
  ];

  const onDateChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);

    if (start && end) {
      const days = getDatesInRange(start, end);
      const validDays = days.filter(
        (day) => !excludedDates.some((ex) => isSameDay(ex, day)),
      );

      const initialLeaveDetails = validDays.map((date) => ({
        date,
        leaveType: "Full day", // Default leave type
        leaveValue: 1,
      }));
      setLeaveDetails(initialLeaveDetails);
    }
  };

  const handleLeaveTypeChange = (date, leaveType) => {
    const leaveValue = leaveType === "Full day" ? 1 : 0.5;
    setLeaveDetails((prev) =>
      prev.map((detail) =>
        isSameDay(detail.date, date)
          ? { ...detail, leaveType, leaveValue }
          : detail,
      ),
    );
  };

  // Function to handle leave day selection for specific days
  const getTotalLeaveDays = (leaveDetails) => {
    return leaveDetails.reduce((total, detail) => total + detail.leaveValue, 0);
  };

  const handleFeedbackModalOpen = () => {
    setFeedbackModalOpen(true);
  };

  const handleFeedbackModalClose = () => {
    setFeedbackModalOpen(false);
  };

  const validationSchema = Yup.object().shape({
    leaveType: Yup.string().required("Leave Type is required"),
    reason: Yup.string().required("Leave Reason is required"),
  });

  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  // function displayLeaveDates(values) {
  //   const leaveArray = JSON.parse(values);
  //   console.log(leaveArray);
  //   return leaveArray;
  // }
  

  function getEmpName(user) {
    let empName;
    if (user.employee) {
      empName = user.employee.firstName + " " + user.employee.lastName;
    }

    if (user.recruiter) {
      empName = user.recruiter.firstName + " " + user.recruiter.lastName;
    }
    return empName;
  }

  async function handleAdd(values) {
    try {
      // Prepare the payload
      const payload = leaveDetails.map((detail) => ({
        date: moment(detail.date).format("YYYY-MM-DD"), // Format date as YYYY-MM-DD
        leaveType: detail.leaveType,
        value: detail.leaveValue,
      }));

      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}leave/requestLeave`,
        {
          leaveDates: payload,
          leaveType: values.leaveType,
          reason: values.reason,
          Totalvalue: getTotalLeaveDays(leaveDetails),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        handleFeedbackModalClose();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      console.error("Error submitting leave details:", error);
      setLoader(false);
    }
  }

  async function handleApprovalPermission(id, status,userId) {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_SERVER}permission/approveOrDisapprovePermission`,
        {
          id: id,
          status: status,
          userId: userId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        },
      );

      setLoader(false);
      if (response.data.status) {
        handleNotificationCall("success", response.data.message);
        fetchPendingLeaves();
      } else {
        handleNotificationCall("error", response.data.message);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error submitting leave details:", error);
    }
  }

  return (
    <div style={{ marginTop: "20px" }}>
      <Grid container direction="row" spacing={2} className={classes.heading}>
   
        {/* <Grid item xs={3} sm={5} md={4} lg={6} className={classes.drawerClose}>
          <div className={classes.lgButton}>
            <Button
              variant="contained"
              size="small"
              color="primary"
              startIcon={<AddCircleIcon />}
              className={classes.addUser}
              onClick={handleFeedbackModalOpen}
            >
              Apply Leave
            </Button>
          </div>

          <div className={classes.smButton}>
            <Button
              variant="contained"
              size="small"
              startIcon={<AddCircleIcon />}
              className={classes.addUser}
              color="primary"
              onClick={handleFeedbackModalOpen}
            >
              Leave
            </Button>
          </div>
        </Grid> */}
      </Grid>

      <Grid container spacing={2}>
        {pendingPermissionData.map((item) => (
          <Grid item xs={12} sm={12} md={6} lg={6} key={item}>
            <Card
              style={{
                margin: "0.5rem",
                background:"#cddeff",
                boxShadow:
                  "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px",
              }}
            >
              <CardContent>
                {/* Header */}
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="flex-start"
                >
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="flex-start"
                  >
                    <Box>
                      <Typography
                        style={{ fontWeight: 700, color: "#116D6E" }}
                        variant="h6"
                      >
                        {capitalizeFirstLetter(item.user.roleName)}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="h6">
                        {getEmpName(item.user)}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    mb={2}
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                    alignItems="flex-start"
                  >
                    <Typography variant="body2" color="textSecondary">
                      Permission Date:
                    </Typography>
                    <RadioGroup row value="Leave">
                    {moment(item.fromDate).format("DD-MM-YYYY")}
                    </RadioGroup>
                  </Box>
                  <Typography variant="h6" style={{ fontWeight: "bold" }}>
                    Permission Request
                  </Typography>
                </Box>
                {/* Leave Type */}

                {/* Date Selection */}
                <Grid
                  container
                  spacing={2}
                  alignItems="flex-start"
                  justifyContent="flex-start"
                >
                  <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary">
                    Permission Timing:
                    </Typography>
                    <Box
                      border={1}
                      borderColor="#E0E0E0"
                      borderRadius={4}
                      p={1}
                    >
                      <Typography>
                        {moment(item.fromTime).format("LT")} -{" "}
                        {moment(item.toTime).format("LT")}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary">
                      Duration
                    </Typography>
                    <Box
                      display="flex"
                      alignItems="center"
                      border={1}
                      borderColor="#E0E0E0"
                      borderRadius={4}
                      p={1}
                    >
                    {(() => {
                        const fromTime = moment(item.fromTime);
                        const toTime = moment(item.toTime);
                        const duration = moment.duration(toTime.diff(fromTime));
                        const hours = Math.floor(duration.asHours());
                        const minutes = duration.minutes();
                        return (
                          <Typography>
                            {hours <= 1 ? hours+" Hour" : hours+" Hours"}
                          </Typography>
                        );
                      })()}
                      
                    </Box>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={2}
                  alignItems="flex-start"
                  justifyContent="flex-start"
                >
                  <Grid item xs={12}>
                    <Box display="flex" flexDirection="column" gridGap={2}>
                      <Typography variant="body2" component="p" style={{fontFamily:700}}>
                        Reason:
                      </Typography>
                      <Typography variant="body2" component="p">
                        {item.reason}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>

                {/* Action Buttons */}
                <Box mt={3} display="flex" justifyContent="flex-start" gap={2}>
                  <Button
                    variant="contained"
                    color="primary"
                    className={classes.green}
                    style={{ marginRight: "1rem", textTransform: "none" }}
                    onClick={() => {
                      handleApprovalPermission(item.id, "APPROVED",item.user.id);
                    }}
                  >
                    Approve
                  </Button>
                  <Button
                    variant="outlined"
                    color="secondary"
                    style={{ textTransform: "none" }}
                    onClick={() => {
                      handleApprovalPermission(item.id, "REJECTED",item.user.id);
                    }}
                  >
                    Decline
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      {pendingPermissionData.length <= 0 && (
        <NoDataFound height="80vh" message="No Data Found"/>
      )}

      <Dialog
        open={feedbackModalOpen}
        fullWidth
        maxWidth="sm"
        onClose={handleFeedbackModalClose}
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={handleSubmit(handleAdd)}>
          <h3 style={{ padding: "12px 12px", margin: 0 }}>Apply Leave</h3>
          {/* <DialogTitle style={{fontSize:"24px"}}>Subscribe</DialogTitle> */}
          <DialogContent>
            <Grid container direction="row" spacing={2}>
              <Grid item xs={12} md={12} lg={6}>
                <Grid container direction="row" spacing={2}>
                  <Grid item xs={12} md={12} lg={12}>
                    <InputLabel shrink htmlFor="leaveType">
                      Leave Type
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <Controller
                        name="leaveType"
                        control={control}
                        render={({ field: { onChange, value } }) => (
                          <Select
                            value={value}
                            onChange={(e) => onChange(e.target.value)} // Register value changes
                            error={!!errors.leaveType} // Error handling
                            classes={{
                              root: classes.customSelectField,
                              icon: classes.customSelectIcon,
                            }}
                            disableUnderline
                          >
                            <MenuItem value="">Select option</MenuItem>
                            <MenuItem value="casual">Casual Leave</MenuItem>
                            <MenuItem value="sick">Sick Leave</MenuItem>
                          </Select>
                        )}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.leaveType?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                  {/* Date Picker */}
                  <Grid item xs={12}>
                    <InputLabel style={{ marginBottom: "8px" }} shrink>
                      Leave Dates
                    </InputLabel>
                    <DatePicker
                      selected={startDate}
                      onChange={onDateChange}
                      minDate={new Date()}
                      maxDate={addMonths(new Date(), 5)}
                      startDate={startDate}
                      endDate={endDate}
                      selectsRange
                      inline
                      showDisabledMonthNavigation
                    />
                  </Grid>
                  <Grid item xs={12} md={12} lg={12}>
                    <InputLabel shrink htmlFor="reason">
                      Leave Reason
                    </InputLabel>
                    <FormControl className={classes.margin}>
                      <TextField
                        multiline
                        minRows={5}
                        size="small"
                        InputProps={{ disableUnderline: true }}
                        classes={{ root: classes.customTextField }}
                        placeholder="Enter your Feedback Message..."
                        name="reason"
                        {...register("reason")}
                        error={errors.reason ? true : false}
                      />

                      <Typography variant="inherit" color="error">
                        {errors.reason?.message}
                      </Typography>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>

              <Grid item xs={12} md={12} lg={6}>
                <div style={{ background: "#faf5b1", padding: "10px" }}>
                  <Grid>
                    {leaveDetails.length > 0 && (
                      <div>
                        <h3>Selected Leave</h3>
                        <ul style={{ padding: "0" }}>
                          {leaveDetails.map((detail, index) => (
                            <li
                              key={index}
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "5px",
                              }}
                            >
                              <span style={{ flex: "1" }}>
                                {detail.date.toDateString()} -{" "}
                              </span>
                              <select
                                style={{
                                  width: "80px",
                                  border: "none",
                                  outline: "none",
                                }}
                                value={detail.leaveType}
                                onChange={(e) =>
                                  handleLeaveTypeChange(
                                    detail.date,
                                    e.target.value,
                                  )
                                }
                              >
                              <option value="">
                                  Select option
                                </option>
                                <option value="First Half">
                                  Half day - 1st Half
                                </option>
                                <option value="Second Half">
                                  Half day - 2nd Half
                                </option>
                                <option value="Full day">Full day</option>
                              </select>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </Grid>
                  <Box
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <strong>Total Leave:</strong>{" "}
                    <strong>{getTotalLeaveDays(leaveDetails)} days</strong>
                  </Box>
                  <Grid style={{ padding: "24px" }}>Your Leave Details</Grid>
                </div>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions style={{ padding: "12px 24px" }}>
            <Button
              onClick={handleFeedbackModalClose}
              variant="contained"
              color="secondary"
              size="small"
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              size="small"
              type="submit"
            >
              Send
            </Button>
          </DialogActions>
        </form>
      </Dialog>

      <Backdrop className={classes.backdrop} open={loader}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}
